module.exports = __webpack_public_path__ + "static/media/IconFailed.c03ef8c3.svg";